import axios from 'axios';
import {getApiConfig} from '../config/configProvider';

const strapiUrl = '/api/olympus/strapi';
export default class jjContentApi {
  static getContentBySlug(contentName, hostDomain) {
    const config = getApiConfig();
    const url = `${hostDomain || ''}${config.strapiUrl ||
      strapiUrl}/jjContentBySlug/${contentName}`;
    return axios.get(url).then(res => res.data);
  }
}
